import { useEffect, useState } from 'react';
import { authService } from '../services/auth/auth.service';

// GUIDs can be returned in different case and with either '-' or '_' separators,
// so normalize both sides before comparing.
const normalizeGUID = (guid: string): string => guid.toLowerCase().replace(/_/g, '-');

export const useVisibilityGUID = (guids: string[]) => {
  const [state, setState] = useState<boolean>(false);
  useEffect(() => {
    const subCustomerGuid = authService.sub.customerGUID().subscribe((guid) => {
      const specialCustomers: string[] = guids.map(normalizeGUID);
      setState(specialCustomers.includes(normalizeGUID(guid)));
    });
    return () => {
      subCustomerGuid.unsubscribe();
    };
  }, []);
  return state;
};
